import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import ActivityCard from './ActivityCard';
import { useT } from '../i18n/LanguageContext';
import { useActivities } from '../hooks/use-activities';
import { selectVariety } from '../lib/variety';

export default function InspiredTrips() {
  const t = useT()
  const { data } = useActivities({ limit: 200 })
  const activities = data?.items || []

  const inspired = useMemo(() => selectVariety(activities, 6), [activities])

  return (
    <section className="py-20 md:py-28 bg-[#f7f9fb]">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-12 gap-4">
          <div>
            <p className="text-[#c8a25a] text-sm font-semibold tracking-widest uppercase mb-2">{t('inspired.eyebrow')}</p>
            <h2 className="text-4xl md:text-5xl font-bold text-[#14213d]">
              {t('inspired.title')}
            </h2>
          </div>
          <Link to="/activities" className="text-[#1fa5a3] font-semibold hover:text-[#c8a25a] transition-colors self-start md:self-end">
            {t('inspired.viewAll')} →
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {inspired.map((a) => (
            <ActivityCard key={a.id} activity={a} />
          ))}
        </div>
      </div>
    </section>
  );
}
